import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../firebaseConfig'; // Import your Firebase auth instance

const LoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');

    const handleGoogleLogin = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            // Send the user's profile info to your backend
            const backendResponse = await axios.post('/api/users/login', {
                googleId: user.uid,
                email: user.email,
                name: user.displayName,
                profilePicture: user.photoURL,
            });

            // Your backend sends back its own JWT
            const appToken = backendResponse.data.token;
            
            // Store the application's token
            localStorage.setItem('app_token', appToken);

            // Redirect user to the settings page after login
            navigate('/settings', { state: { message: 'Login successful!' } });
            
        } catch (error) {
            console.error('Error during Google login:', error);
        }
    };
    
    // Placeholder function for email/OTP login
    const handleEmailLogin = (e) => {
        e.preventDefault();
        alert("Email/OTP login is not yet implemented.");
    };

    return (
        <div className="login-page-container">
            <div className="login-card">
                <h2>Your Active Life, All in One Place</h2>
                <p>Track your progress. Join for new learning.</p>
                
                <button onClick={handleGoogleLogin} className="google-login-button">
                    <svg className="google-icon" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"></path><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.3v2.84C4.08 20.73 7.7 23 12 23z" fill="#34A853"></path><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.3C1.48 8.88 1 10.43 1 12s.48 3.12 1.3 4.93l3.54-2.84z" fill="#FBBC05"></path><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 4.08 3.27 2.3 6.26l3.54 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path><path d="M1 1h22v22H1z" fill="none"></path></svg>
                    <span>Sign Up With Google</span>
                </button>
                
                <div className="divider-text">or sign up with email</div>
                
                <form onSubmit={handleEmailLogin} className="login-form">
                    <label htmlFor="email">Email</label>
                    <input 
                        type="email" 
                        id="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        placeholder="Enter Email" 
                        className="styled-input" 
                    />
                    
                    <label htmlFor="otp">OTP</label>
                    <input 
                        type="text" 
                        id="otp" 
                        value={otp} 
                        onChange={(e) => setOtp(e.target.value)} 
                        placeholder="Enter OTP" 
                        className="styled-input" 
                    />
                    
                    <button type="submit" className="course-button signup-button">
                        Sign Up
                    </button>
                </form>

                <p className="terms-text">
                    By signing up, you agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
                </p>
            </div>
        </div>
    );
};

export default LoginPage;
